const makeId = (index = 0) => {
	const g =
		(typeof window !== 'undefined' && window) ||
		(typeof global !== 'undefined' && global) ||
		{};
	if (g.crypto?.randomUUID) return g.crypto.randomUUID();
	return `${Date.now()}-${index}-${Math.random().toString(16).slice(2)}`;
};

export default makeId;
